import { render, staticRenderFns } from "./CashierOrder.vue?vue&type=template&id=22edafb2&scoped=true&"
import script from "./CashierOrder.vue?vue&type=script&lang=js&"
export * from "./CashierOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22edafb2",
  null
  
)

export default component.exports